<section class="content-layout" [brightsideWebFb]="{ event_name: 'contest_intro' }">
  <bw-action-article-legacy>
    <ui-nav-exit-close back-action-top [trackingDetail]="{ event_name: 'contest_intro' }" (exitActionHandler)="backToIntro()">
    </ui-nav-exit-close>

    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <typography-legacy text-large-regular color="var(--secondary-text)" class="mb-sm">
            {{ 'CONTEST_RULES_TITLE' | translate }}
          </typography-legacy>
          <p title-medium class="mb-sm">{{ 'CONTEST_RULES_DESC' | translate }}</p>
          <typography-legacy text-small color="var(--secondary-text)" class="mb-sm">
            <div [innerHTML]="'CONTEST_RULES_BODY' | translate"></div>
          </typography-legacy>
        </div>
      </div>
    </div>
  </bw-action-article-legacy>
</section>
